module.exports = __webpack_public_path__ + "static/media/sports (4).25310566.webp";